<template>
	<div>
		<div id="relateMainTaskHead"></div>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="light" style="width: 100%" size="mini" v-scrollBar:tableArg height="300" border>
			<el-table-column width="55">
				<template slot-scope="scope">
					<el-radio v-model="templateRadio" :label="scope.$index" @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;</el-radio>
				</template>
			</el-table-column>
			<el-table-column label="任务名称" show-overflow-tooltip>
				<template slot-scope="scope">
					<span style="margin-left: 10px">{{ scope.row.TASKNAME }}</span>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" show-overflow-tooltip>
				<template slot-scope="scope">
					<i class="el-icon-time"></i>
					<span style="margin-left: 10px">{{ replaceFormat(scope.row.CREATETIME) }}</span>
				</template>
			</el-table-column>
		</el-table>
		<div style="text-align: center;padding-bottom: 15px;padding-top: 10px;">
			<el-button type="primary" plain @click="toRelate">关联为主任务</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getToken
	} from "../../../util/auth";
	import {
		GetAllCommonSetTaskByServerId,
		AddSonTaskBySetCommonTask
	} from "@/api/modules/basicData/task";
	const cookieUser = getToken();
	export default {
		data() {
			return {
				templateRadio: -1,
				tableData: [],
				multipleSelection: []
			}
		},
		mounted() {},
		watch: {},
		created() {
			this.toGetMainTask()
		},
		methods: {
			getUser() { //pc调用
				var  url = window.location.href;
				if (url.indexOf("?") != -1) {
					let  str = url.split("?");
					str = str[1];
					if (str.indexOf("=") != -1) {
						let  str = url.split("=");
						str = str[1]; //28
						GetSysUserByCode(str).then(res => {
							res.userId = res.ID
							res.realName = res.NAME
							this.currentUser = res
							this.getAllNotification('')
						})
					}
				} else { //web调用
					this.currentUser = getToken()
					this.getAllNotification('')
				}
			},
			getTemplateRow(index, row) {
				this.multipleSelection = row;
				console.log(row)
			},
			replaceFormat(time) {
				if(time != null) {
					time = time.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
					if(time.indexOf("Z")) {
						time = time.replace("Z", "");
					}
					return time
				} else {
					return ''
				}
			},
			toGetMainTask() {
				GetAllCommonSetTaskByServerId().then((res) => {
					this.tableData = res
				})
			},
			toRelate() {
				if(this.templateRadio < 0)
					return;
				let TASKCONTACT = {
					CREATETIME: this.CurentTime(new Date()).toString(),
					CREATEUSERID: cookieUser.userId,
					CREATEUSERNAME: cookieUser.realName,
					MAINTASKID: this.multipleSelection.TASKID,
					SONTASKID: this.$route.query.taskid
				}
				let curTask = this.$store.state.task.curTask
				AddSonTaskBySetCommonTask(TASKCONTACT).then((res) => {
					if(res == 1) {
						this.$message({
							showClose: true,
							message: '关联成功',
							type: 'success'
						});
						this.templateRadio = -1
						//this.$emit("closeDialog")
						this.closeWinform()
					} else {
						this.$message({
							showClose: true,
							message: '关联失败',
							type: 'error'
						});
					}
				})
			},
			closeWinform() {
				if(typeof jsObj1 == "undefined")
					return;
				jsObj1.execute("")
			},
			CurentTime(now) {
				var year = now.getFullYear(); //年
				var month = now.getMonth() + 1; //月
				var day = now.getDate(); //日
				var hh = now.getHours(); //时
				var mm = now.getMinutes(); //分
				var ss = now.getSeconds(); //秒
				var clock = year + "-";
				if(month < 10)
					clock += "0";
				clock += month + "-";
				if(day < 10)
					clock += "0";
				clock += day + " ";
				if(hh < 10)
					clock += "0";
				clock += hh + ":";
				if(mm < 10) clock += '0';
				clock += mm + ":";
				if(ss < 10) clock += '0';
				clock += ss;
				return(clock);
			},
		},
		computed: {}
	}
</script>

<style scoped="true">

</style>